import React from 'react';
import { Scissors, Ruler, WashingMachine, Shirt } from 'lucide-react';
import { pricing } from '../../mock';
import { useBooking } from '../../BookingContext';

const iconMap = { Scissors, Ruler, WashingMachine, Shirt };

export default function Pricing() {
  const { open: onBook } = useBooking();
  return (
    <section id="pricing" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="zp-section-title">
            Our <span className="zp-gradient-text">Pricing</span>
          </h2>
          <p className="mt-4 text-slate-600">Choose a service that suits your needs.</p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricing.map((p) => {
            const Icon = iconMap[p.icon] || Scissors;
            return (
              <div
                key={p.title}
                className={`zp-card p-6 flex flex-col items-center text-center relative ${
                  p.featured ? "ring-2 ring-[#E91E80]" : ""
                }`}>
                {p.featured && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#E91E80] text-white text-[11px] font-semibold px-3 py-1">
                    Popular
                  </span>
                )}
                <div className="h-14 w-14 rounded-2xl bg-pink-50 text-[#E91E80] grid place-items-center mb-4">
                  <Icon size={26} />
                </div>
                <div className="text-lg font-bold text-slate-900">
                  {p.title}
                </div>
                <div className="mt-2 text-sm text-slate-500">{p.note}</div>
                <div className="mt-2 flex items-baseline gap-1">
                  <span className="text-3xl font-extrabold text-slate-900">
                    {p.price}
                  </span>
                  {p.sub && (
                    <span className="text-sm text-slate-500">{p.sub}</span>
                  )}
                </div>
                <button
                  onClick={onBook}
                  className="mt-10 zp-pill-btn text-sm text-center">
                  Book Now
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
